module.exports = __webpack_public_path__ + "img/fan_forward.ae6b8f39.svg";